import { BASE_URL } from '../../config'
import history from '../../history';
import { SET_NOTIF_LIST, REQ_NOTIF_LIST, SET_ERROR_REQ_NOTIF } from '../../utils/constants/actionTypes';
import {GNotif, UReadNotif} from '../../config/api'
import bugsnagClient from '../../config/bugsnag';

export default ( ClientID ) => async (dispatch) => {
    dispatch({type : REQ_NOTIF_LIST});
    try{
        let res = await fetch(`${BASE_URL}${GNotif}`, {
            method : 'GET',
            credentials: 'include',
            headers : { 
                'X-Client-ID' : ClientID,
                'Content-Type' : "application/json"
            }
        })
        
        let hasil = await res.json()
        if( res.status === 200 ){
            dispatch({ type: SET_NOTIF_LIST, payload : hasil.result.notifications })
        } else{
            dispatch({ type: SET_ERROR_REQ_NOTIF, payload : hasil.status.message});
            console.log('1. Error Request Notififaction : ', hasil.status.message)
            bugsnagClient.notify(new Error(`Notif.js/ (line 25) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
        }
    } catch(err){
        dispatch({ type: SET_ERROR_REQ_NOTIF, payload : err.message});
        console.log('2. Error Request Notification : ', err.message);
        bugsnagClient.notify(new Error(`Notif.js/ (line 30) ===> catch - ${err.message}`))
    }
}




export const readNotif = (ClientID, NotifID) => async (dispatch) => {
    try{
        let res = await fetch(`${BASE_URL}${UReadNotif(NotifID)}`, {
            method : 'POST',
            credentials: 'include',
            headers : { 
                'X-Client-ID' : ClientID,
                'Content-Type' : "application/json"
            }
        })
        
        let hasil = await res.json()
        if( res.status === 200 ){
            //Redirect to detil page
            history.push(`/notifikasi/detil/${NotifID}`);
			window.location.reload();
        } else{
            console.log('1. Error Read Notififaction : ', hasil.status.message)
            bugsnagClient.notify(new Error(`Notif.js/readNotif (line 55) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
        }
    } catch(err){
        console.log('2. Error Read Notification : ', err.message);
        bugsnagClient.notify(new Error(`Notif.js/readNotif (line 59) ===> catch - ${err.message}`))
    }
}